(function () {
  angular.module("akitabox.room.list", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.pinValue",
    "akitabox.core.services.room",
  ]);
})();
